export default __webpack_public_path__ + "static/media/ic_comment.f2b05afe.svg";